import React, { FC } from 'react';
import { Drawer } from 'src/components/widgets/drawer';
import { SkeletonHeaderWrapper, SkeletonSectionWrapper, SkeletonStatusBarWrapper } from './styled';
import { SidePanelHeaderSkeleton, SidePanelSectionSkeleton as SidePanelSectionContentSkeleton, SidePanelStatusSkeleton } from './skeletons';

export const SidePanelSkeleton: FC<{ onClose: () => void }> = ({ onClose }) => (
    <Drawer isOpen={true} onClose={onClose} header={<SidePanelSkeletonHeader />} width={580}>
        <SidePanelSkeletonStatusBar />
        {[0, 1, 2].map((index) => (
            <SidePanelSkeletonSection key={index} />
        ))}
    </Drawer>
);

const SidePanelSkeletonHeader: FC = () => (
    <SkeletonHeaderWrapper>
        <SidePanelHeaderSkeleton />
    </SkeletonHeaderWrapper>
);

const SidePanelSkeletonStatusBar: FC = () => (
    <SkeletonStatusBarWrapper>
        <SidePanelStatusSkeleton />
    </SkeletonStatusBarWrapper>
);

const SidePanelSkeletonSection: FC = () => (
    <SkeletonSectionWrapper>
        <SidePanelSectionContentSkeleton />
    </SkeletonSectionWrapper>
);
